import React, { useRef, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import axios from 'axios';
import { toast } from 'react-toastify';
 import email from '../../images/email.png';
 import twitter from '../../images/overlayTwitter.png';
 import telegram from '../../images/overlayTelegram.png';
 import cross from '../../images/landing/cross.svg';

const RegisterModal = ({toggle, onCloseModal}) => {
  const [isDisable, setDisable] = useState(false);
  const emailRef = useRef();

  const subscripeEmail = async () => {
    setDisable(true);
    const email = emailRef.current.value;
    try {
      const response = await axios.post(`/api/app/notification/subscribe/email?email=${email}`);
      toast.success(response.data.message);
      setDisable(false);
      onCloseModal();
    }
    catch (e){
      setDisable(false);
      toast.error(e.response.data.message)
      console.log(e)
    }
  }

  const keyHandler = (e) => {
    if (e.key === 'Enter') {
      subscripeEmail();
    }
  }

    return (
      <div>
        <Modal open={ toggle } onClose={onCloseModal}  classNames={ {
        modal: 'register',
        overlayAnimationIn: 'customEnterOverlayAnimation',
          overlayAnimationOut: 'customLeaveOverlayAnimation',
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
      } } center
        >
          <button onClick={onCloseModal} className="cross btn"><img width="80%" src={cross} alt=""/></button>
          <p>MONSTERS ARE EAGER TO MEET YOU!</p>
          <h1>REGISTER INTEREST</h1>
          <div className="main-div">
            <div className="left">
              <img src={email} alt=""/>
              <h5>STAY UPDATED</h5>
              <span>Enter your email to register your interest for upcoming updates and NFTs of Monsters Clan. Registering your interest will give you early updates and news about the Monsters Clan NFT game.</span>
              <div className="input-group mb-3">
                <div className="input-div">
                  <input placeholder="Enter your email" type="text" 
                    ref={emailRef}
                    onKeyDown={keyHandler}
                   className="form-control"/>
                </div>
                <button onClick={subscripeEmail} className="btn buy" 
                disabled={isDisable} type="button">Register</button>
              </div>
            </div>
            <div className="main-right">
              <div className="right">
              <a target="_blank" rel="noreferrer" href="https://t.me/MONSofficial"><img src={telegram} alt=""/></a>
                <p>JOIN OUR COMMUNITY</p>
                <a target="_blank" rel="noreferrer" href="https://t.me/MONSofficial" className="btn buy">Join Telegram Channel</a>
              </div>
              <div className="right">
              <a target="_blank" rel="noreferrer" href="https://twitter.com/_Monstersclan"><img src={twitter} alt=""/></a>
                <p>FOLLOW US ON TWITTER</p>
                <a target="_blank" rel="noreferrer" href="https://twitter.com/_Monstersclan" className="btn buy">Follow us on Twitter</a>
              </div>
            </div>
          </div>
        </Modal>
        </div>
    );
}
export default RegisterModal;